<div class="row p-2 mb-3 align-items-center">
  <div class="col-12 col-md-7 text-start">
    <div class="page-title-heading">
      <div class="page-title-icon"><i class="fa-solid fa-table-list"></i></div>
      <div>
        Composition par classe
        <div class="page-title-subheading">Compositions par classe</div>
      </div>
    </div>
  </div>
  <div class="col-12 col-md-5 text-end">
    <app-header></app-header>
  </div>
</div>

<div  class="card mb-3">
  <div class="card-body py-3">
    <div class="row g-3 align-items-end">
      <div class="col-12 col-md-6">
        <label for="" class="form-label mb-0">Choisir la classe</label>
        <select class="form-select form-select-sm" (change)="loadCompositions1($event)" >
            <option selected disabled></option>
            <option *ngFor="let classroom of classrooms" [value]="classroom?.id">{{classroom?.name}}</option>
        </select>
      </div>
      <div class="col-12 col-md-6">
        <label for="" class="form-label mb-0">Choisir la période</label>
        <select class="form-select form-select-sm" [(ngModel)]="periodId" name="periodId" (change)="loadCompositions2($event)">
            <option selected disabled></option>
            <option *ngFor="let p of periods" [value]="p?.id">{{p?.name}}</option>
        </select>
      </div>
    </div>
  </div>
</div>
<div class="container">
    <div class="d-flex justify-content-center mb-3">
        <button *ngIf="is_published!=null && !is_published" (click)="setStatus(1)" type="button" class="btn btn-outline-success btn-sm btn-label waves-effect waves-light me-3">
            Activer</button>
           <button  *ngIf="is_published!=null &&  is_published" (click)="setStatus(0)" type="button" class="btn btn-outline-danger btn-sm btn-label waves-effect waves-light me-3">
            Désactiver</button>
    </div>
 <div class="card">
    <div class="card-body">
        <p>{{compositions!.length}} élément(s)</p>
        <div class="table-responsive">
        <table class="table table-sm table-striped table-bordered" >
            <thead class="">
                <tr>
                    <th style="width: 10px;">#</th>
                    <th>Matière</th>
                    <th>Enseignant</th>
                    <th>Evaluations effectuées</th>
                    <th>(Evaluations validées / Evaluations soumises)</th>
                </tr>
            </thead>
            <tbody>
                <tr (click)="checked(d)" [class.table-active]="selected_data?.id === d.id" style="cursor: pointer;" *ngFor="let d of compositions ">
                    <td>
                        <div class="form-check mb-2">
                            <input (click)="checked(d)" class="form-check-input" type="radio" [checked]="selected_data?.id === d.id" name="flexRadioDefault">
                        
                        </div>
                    </td>
                    <td>{{d.course?.name}}</td>
                    <td>{{d.pac?.professor?.lastname}}  {{d.pac?.professor?.firstname}}</td>
                    <td>
                        <p>{{d.compositions?.length}}</p>
                        <button *ngIf="d.compositions?.length !=0" (click)="show(showContent,d.compositions)" class="btn btn-sm btn-info">Voir les évaluations</button>
                    </td>
                    <td>
                        {{getState(d.compositions)}}
                    </td>

                </tr>
            
            </tbody>
        </table>
        </div>
        <div class="text-end">
            <button *ngIf="canCalculate" type="button" class="btn btn-sm btn-outline-danger" (click)="generateBulletin()">Calculer les moyennes de cette classe</button>
        </div>
        <pagination-controls 
        id="ngxP1"
        (pageChange)="getPage($event)"
      [maxSize]="9"
      [directionLinks]="true"
      [autoHide]="true"
      [responsive]="true"
      [previousLabel]="'Previous'"
      [nextLabel]="'Next'"
      [screenReaderPaginationLabel]="'Pagination'"
      [screenReaderPageLabel]="'page'"
      [screenReaderCurrentLabel]="'You\'re on page'">
     </pagination-controls>
    </div>
 </div>
</div>



<ng-template #showContent let-c="close" let-d="dismiss">
    <div class="modal-header">
        <h4 class="modal-title" id="modal-basic-title">Toutes les évaluations</h4>
        <button type="button" class="btn-close" aria-label="Close" (click)="d('Cross click')"></button>
      </div>

      <div class="modal-body">
        <div class="table-responsive table-card">
            <dl *ngFor="let c of compositions2">
                <dt>{{c.name}} effectuée le {{c.created_at | date:"dd-MM-yyyy"}}</dt>
                <dd>{{c.type}}</dd>
                <dd>
                    <span *ngIf="!c.is_confirmed" class="badge bg-secondary">Evalution simple</span>
                    <span *ngIf="c.is_confirmed && !c.is_published" class="badge bg-warning">En attente de validation</span>
                    <span *ngIf="c.is_confirmed && c.is_published && c.for_average" class="badge bg-success">A inclure dans le calcul des moyennes</span>
                    <span *ngIf="c.is_confirmed && c.is_published && !c.for_average" class="badge bg-primary">A ne pas inclure dans le calcul des moyennes</span>
                </dd>
            </dl>
        </div>
      </div>
</ng-template>
